import Swiper, { Mousewheel, Scrollbar } from "swiper";

export const featuredCarousel = () => {
  const featuredCarousels = document.querySelectorAll("[data-js-featured-carousel]");

  for (const featuredCarousel of featuredCarousels) {
    const carousel = featuredCarousel.querySelector(".featured-carousel");

    const scrollbarElement = featuredCarousel.querySelector(
      `.swiper-scrollbar`
    ) as HTMLElement;

    new Swiper(carousel as HTMLElement, {
      modules: [Mousewheel, Scrollbar],
      direction: "horizontal",
      loop: false,
      spaceBetween: 0,
      slidesPerView: "auto",
      mousewheel: {
        sensitivity: 2,
        forceToAxis: true,
      },
      scrollbar: {
        el: scrollbarElement,
        hide: false,
        snapOnRelease: true,
        draggable: true,
        enabled: true
      },
    });
  }
};
